import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ModalGroup from "site-apps/assets/ModalGroup";
import ModalIslandSelect from "site-apps/distribution/island/ModalIslandSelect";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import ContainerTypesSelect from "site-apps/assets/components/ContainerTypesSelect";

const TabGeneral = ({ item, add, btnDelete, paramsTypes, formData, setFormData }) => {
    const { t: _tF } = useTranslation("forms");
    const [showModalGroup, setShowModalGroup] = useState(false);
    const [showModalIsland, setShowModalIsland] = useState(false);
    const [group, setGroup] = useState({ id: item.group, name: item.group_name });
    const [island, setIsland] = useState({
        id: item.island,
        name: item.island_name,
    });
    const onSelectGroup = (e) => {
        setShowModalGroup(true);
        subscribeEvent("groupasset:modalselect:change", changeGroup);
    };
    const changeGroup = (e) => {
        setGroup({ id: e.detail.id, name: e.detail.name });
        let data = { ...formData };
        data.group = e.detail.id;
        data.group_name = e.detail.name;
        setFormData(data);
        unsubscribeEvent("groupasset:modalselect:change", changeGroup);
    };
    const onSelectIsland = (e) => {
        setShowModalIsland(true);
        subscribeEvent("island:modalselect:change", changeIsland);
    };
    const changeIsland = (e) => {
        setIsland({ id: e.detail.id, name: e.detail.name });
        let data = { ...formData };
        data.island = e.detail.id;
        data.island_name = e.detail.name;
        setFormData(data);
        unsubscribeEvent("island:modalselect:change", changeIsland);
    };
    useEffect(() => {
        return () => {
            unsubscribeEvent("groupasset:modalselect:change", changeGroup);
            unsubscribeEvent("island:modalselect:change", changeIsland);
        };
    }, []);

    return (
        <>
            <div className="container">
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="uuid" className="col-form-label">
                            UID
                        </label>
                    </div>
                    <div className="col-7">
                        <input type="text" className="form-control" id="uid" name="uid" defaultValue={item.uid} disabled={true} />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="tag" className="col-form-label">
                            TAG
                        </label>
                    </div>
                    <div className="col-7">
                        <input type="text" className="form-control" id="tag" name="tag" defaultValue={item.tag} />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="active" className="col-form-label">
                            Activo
                        </label>
                    </div>
                    <div className="col-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="active"
                            name="active"
                            defaultChecked={item.active}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="description" className="col-form-label">
                            Descripción
                        </label>
                    </div>
                    <div className="col-9">
                        <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            defaultValue={item.description}
                            rows="4"
                        />
                    </div>
                </div>
            </div>
            <ModalGroup showModalGroup={showModalGroup} setShowModalGroup={setShowModalGroup} />
            <ModalIslandSelect showModalIsland={showModalIsland} setShowModalIsland={setShowModalIsland} />
        </>
    );
};
export default TabGeneral;
